import type * as React from 'react';
import { post } from '@Domain/Api';
import type { BeneficiaryPayload } from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetched';
import beneficiaryCreated, {
	type BeneficiaryCreatedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryCreated';
import beneficiaryCreationFailed, {
	type BeneficiaryCreationFailedAction,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryCreationFailed';
import type CreateBeneficiary from '@Application/Beneficiaries/Beneficiaries/Commands/CreateBeneficiary';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = BeneficiaryCreatedAction | BeneficiaryCreationFailedAction;

export default (command: CreateBeneficiary) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<BeneficiaryPayload>(
				`${parameters.api.host}/api/facilities/${command.facilityId}/beneficiaries`,
				command.toJSON(),
			);

			const action = beneficiaryCreated(payload, command.facilityId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
